import gql from 'graphql-tag';
import SedesServices from './services/sedes-service';
import CuentasPagadorasServices from './services/cuentasPagadoras';

export const formatearNumero = (numero) => {
  if (typeof numero == 'number') {
    numero = numero.toFixed(2);
  }

  if (typeof numero == 'string') {
    numero = parseFloat(numero).toFixed(2);
  }

  return (
    numero
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      // eslint-disable-next-line no-useless-escape
      .replace(/\.([^\.]*)$/, ',$1')
  );
};

export const categoriasRelacionadasConClasificadores = (sedeId, gestion) => {
  const unidadesDeNegocio = [
    {
      id: 1,
      nombre: 'esam',
      sedes: [1, 2, 3, 4, 5, 6, 7, 8, 14, 15, 18, 19, 20, 22, 23, 25, 26, 37, 45, 46, 50, 51, 80, 125],
    },
    {
      id: 2,
      nombre: 'cca',
      sedes: [9, 10, 48, 79],
    },
    {
      id: 3,
      nombre: 'ck',
      sedes: [11, 12, 13, 47, 81],
    },
    {
      id: 4,
      nombre: 'cast',
      sedes: [17],
    },
    {
      id: 5,
      nombre: 'esam_latam',
      sedes: [16, 52],
    },
    {
      id: 6,
      nombre: 'cybercorp',
      sedes: [21, 34, 35, 36, 40, 41, 44],
    },
    {
      id: 10,
      nombre: 'digital_business_school',
      sedes: [24, 27, 28, 29, 30, 31, 32, 33, 42, 53, 107],
    },
    {
      id: 11,
      nombre: 'wobi',
      sedes: [38],
    },
    {
      id: 12,
      nombre: 'cctp',
      sedes: [39],
    },
    {
      id: 13,
      nombre: 'new_center',
      sedes: [41],
    },
    {
      id: 14,
      nombre: 'ispi',
      sedes: [
        49, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 110,
        111, 112, 113, 114,
      ],
    },
    {
      id: 15,
      nombre: 'upi',
      sedes: [
        82, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 102, 103, 104, 105, 106, 108, 109, 115, 116,
        117, 118, 119, 120, 121, 122, 123, 124, 126,
      ],
    },
  ];

  const nombreUnidadNegocio = unidadesDeNegocio.find((unidadDeNegocio) =>
    unidadDeNegocio.sedes.includes(sedeId),
  ).nombre;

  const categorias = obtenerCategorias(gestion);

  return categorias[nombreUnidadNegocio];
};

const obtenerCategorias = (gestion) => {
  if (gestion == '2023') {
    return {
      esam: {
        matricula: {
          id: 224,
          nombre: 'Ingreso por Matricula',
          codigo: '11201',
        },
        colegiatura: {
          id: 225,
          nombre: 'Ingreso por Colegiatura/Modulos',
          codigo: '11202',
        },
        certificacion: {
          id: 227,
          nombre: 'Ingreso por Tramitación de Certificación',
          codigo: '11204',
        },
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      cca: {
        mensualidad: {
          id: 229,
          nombre: 'Ingreso por Mensualidades',
          codigo: '11206',
        },
        colegiatura: {
          id: 229,
          nombre: 'Ingreso por Mensualidades',
          codigo: '11206',
        },
        matricula: {
          id: 242,
          nombre: 'Ingresos por Voucher Gold',
          codigo: '11219',
        },
        voucher: {
          id: 242,
          nombre: 'Ingresos por Voucher Gold',
          codigo: '11219',
        },
        'otros ingresos': {
          id: 258,
          nombre: 'Otros Ingresos',
          codigo: '11920',
        },
        certificacion: {
          id: 227,
          nombre: 'Ingreso por Tramitación de Certificación',
          codigo: '11204',
        },
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      ck: {
        mensualidad: {
          id: 229,
          nombre: 'Ingreso por Mensualidades',
          codigo: '11206',
        },
      },
      cast: {
        mensualidad: {
          id: 229,
          nombre: 'Ingreso por Mensualidades',
          codigo: '11206',
        },
      },
      esam_latam: {
        matricula: {
          id: 224,
          nombre: 'Ingreso por Matricula',
          codigo: '11201',
        },
        colegiatura: {
          id: 225,
          nombre: 'Ingreso por Colegiatura/Modulos',
          codigo: '11202',
        },
        certificacion: {
          id: 227,
          nombre: 'Ingreso por Tramitación de Certificación',
          codigo: '11204',
        },
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      cybercorp: {
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      digital_business_school: {
        matricula: {
          id: 224,
          nombre: 'Ingreso por Matricula',
          codigo: '11201',
        },
        colegiatura: {
          id: 225,
          nombre: 'Ingreso por Colegiatura/Modulos',
          codigo: '11202',
        },
        certificacion: {
          id: 227,
          nombre: 'Ingreso por Tramitación de Certificación',
          codigo: '11204',
        },
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      wobi: {
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      cctp: {
        certificacion: {
          id: 227,
          nombre: 'Ingreso por Tramitación de Certificación',
          codigo: '11204',
        },
        mensualidad: {
          id: 229,
          nombre: 'Ingreso por Mensualidades',
          codigo: '11206',
        },
        'otros ingresos': {
          id: 258,
          nombre: 'Otros Ingresos',
          codigo: '11920',
        },
        cursos: {
          id: 238,
          nombre: 'Ingreso por Cursos',
          codigo: '11215',
        },
      },
      new_center: {
        mensualidad: {
          id: 229,
          nombre: 'Ingreso por Mensualidades',
          codigo: '11206',
        },
      },
    };
  }

  return {
    esam: {
      matricula: {
        id: 647,
        nombre: 'INGRESO POR MATRÍCULA',
        codigo: '4.1.1.01.01.001',
      },
      colegiatura: {
        id: 648,
        nombre: 'INGRESO POR COLEGIATURA/MÓDULOS',
        codigo: '4.1.1.01.01.002',
      },
      certificacion: {
        id: 640,
        nombre: 'TRAMITES DE CERTIFICACION - TITULACION',
        codigo: '2.1.1.08.01.003',
      },
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    cca: {
      mensualidad: {
        id: 650,
        nombre: 'INGRESO POR MENSUALIDADES',
        codigo: '4.1.1.01.01.004',
      },
      colegiatura: {
        id: 650,
        nombre: 'INGRESO POR MENSUALIDADES',
        codigo: '4.1.1.01.01.004',
      },
      matricula: {
        id: 653,
        nombre: 'INGRESOS POR VOUCHER GOLD',
        codigo: '4.1.1.01.01.007',
      },
      voucher: {
        id: 653,
        nombre: 'INGRESOS POR VOUCHER GOLD',
        codigo: '4.1.1.01.01.007',
      },
      'otros ingresos': {
        id: 658,
        nombre: 'INGRESOS POR OTROS CONCEPTOS',
        codigo: '4.1.1.01.01.012',
      },
      certificacion: {
        id: 640,
        nombre: 'TRAMITES DE CERTIFICACION - TITULACION',
        codigo: '2.1.1.08.01.003',
      },
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    ck: {
      mensualidad: {
        id: 650,
        nombre: 'INGRESO POR MENSUALIDADES',
        codigo: '4.1.1.01.01.004',
      },
    },
    cast: {
      mensualidad: {
        id: 650,
        nombre: 'INGRESO POR MENSUALIDADES',
        codigo: '4.1.1.01.01.004',
      },
    },
    esam_latam: {
      matricula: {
        id: 647,
        nombre: 'INGRESO POR MATRÍCULA',
        codigo: '4.1.1.01.01.001',
      },
      colegiatura: {
        id: 648,
        nombre: 'INGRESO POR COLEGIATURA/MÓDULOS',
        codigo: '4.1.1.01.01.002',
      },
      certificacion: {
        id: 640,
        nombre: 'TRAMITES DE CERTIFICACION - TITULACION',
        codigo: '2.1.1.08.01.003',
      },
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    cybercorp: {
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    digital_business_school: {
      matricula: {
        id: 647,
        nombre: 'INGRESO POR MATRÍCULA',
        codigo: '4.1.1.01.01.001',
      },
      colegiatura: {
        id: 648,
        nombre: 'INGRESO POR COLEGIATURA/MÓDULOS',
        codigo: '4.1.1.01.01.002',
      },
      certificacion: {
        id: 640,
        nombre: 'TRAMITES DE CERTIFICACION - TITULACION',
        codigo: '2.1.1.08.01.003',
      },
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    wobi: {
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    cctp: {
      certificacion: {
        id: 640,
        nombre: 'TRAMITES DE CERTIFICACION - TITULACION',
        codigo: '2.1.1.08.01.003',
      },
      mensualidad: {
        id: 650,
        nombre: 'INGRESO POR MENSUALIDADES',
        codigo: '4.1.1.01.01.004',
      },
      'otros ingresos': {
        id: 658,
        nombre: 'INGRESOS POR OTROS CONCEPTOS',
        codigo: '4.1.1.01.01.012',
      },
      cursos: {
        id: 649,
        nombre: 'INGRESO POR CURSOS',
        codigo: '4.1.1.01.01.003',
      },
    },
    new_center: {
      mensualidad: {
        id: 650,
        nombre: 'INGRESO POR MENSUALIDADES',
        codigo: '4.1.1.01.01.004',
      },
    },
  };
};

export const validacionDeCampos = (value) => {
  const camposValidos = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
    'total',
  ];

  return Object.keys(value)
    .map((key) => {
      return camposValidos.includes(key);
    })
    .some((item) => item);
};

export const TIPOS_SOLICITUD = {
  RECURSOS: 'recursos',
  GASTOS: 'gastos',
};

export const ESTADOS_SOLICITUD = {
  TODOS: 'Todos',
  SOLICITADO: 'Solicitado',
  ATENDIDO: 'Atendido',
};

export const ESTADOS_DETALLE_SOLICITUD = {
  TODOS: 'Todos',
  PENDIENTE: 'Pendiente',
  APROBADO: 'Aprobado',
  RECHAZADO: 'Rechazado',
  DESEMBOLSADO: 'Desembolsado',
  ANULADO: 'Anulado',
  PAGADO_PARCIALMENTE: 'Pagado parcialmente',
  PAGADO: 'Pagado',
};

export const obtenerColorEstadoDetalleSolicitud = (estado) => {
  if (estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE) {
    return '#ff9800';
  }

  if (estado == ESTADOS_DETALLE_SOLICITUD.APROBADO) {
    return '#4caf50';
  }

  if (estado == ESTADOS_DETALLE_SOLICITUD.RECHAZADO) {
    return '#f44336';
  }

  if (estado == ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO) {
    return '#2196f3';
  }

  if (estado == ESTADOS_DETALLE_SOLICITUD.ANULADO) {
    return '#607d8b';
  }

  if (estado == ESTADOS_DETALLE_SOLICITUD.PAGADO_PARCIALMENTE) {
    return '#880e4F';
  }

  if (estado == ESTADOS_DETALLE_SOLICITUD.PAGADO) {
    return '#9c27b0';
  }

  return '#000000';
};

export const OPERACIONES_DETALLE_SOLICITUD = {
  APROBAR: 'aprobar',
  RECHAZAR: 'rechazar',
  DESEMBOLSAR: 'desembolsar',
  ELIMINAR: 'eliminar',
  REMOVER: 'remover',
  RECHAZAR_MONTO: 'rechazar_monto',
  ANULAR: 'anular',
  CAMBIAR_CUENTAS: 'cambiar_cuentas',
  VER_ADJUNTO: 'ver_adjunto',
  REGISTRAR_PAGO: 'registrar_pago',
  VER_PAGO: 'ver_pago',
  VER_ADJUNTO_NO_SUBIDO: 'ver_adjunto_no_subido',
  ACTUALIZAR_ADJUNTO: 'actualizar_adjunto',
};

export const formatearValorAMoneda = (value) => {
  value = Number(value).toFixed(2);

  return value
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    .replace(/.([^.]*)$/, ',$1');
};

export const ESTADOS_DETALLE_SOLICITUD_OPERACION = {
  [OPERACIONES_DETALLE_SOLICITUD.APROBAR]: ESTADOS_DETALLE_SOLICITUD.APROBADO,
  [OPERACIONES_DETALLE_SOLICITUD.RECHAZAR]: ESTADOS_DETALLE_SOLICITUD.RECHAZADO,
  [OPERACIONES_DETALLE_SOLICITUD.ANULAR]: ESTADOS_DETALLE_SOLICITUD.ANULADO,
};

export const ORIGENES_SEDES = {
  PORTAL: 'portal',
  PRESUPUESTOS: 'presupuestos',
};

export const formatearSede = (origen) => {
  return (sede) => {
    return {
      id: sede.id,
      nombre: sede.nombre,
      origen,
    };
  };
};

export const TIPOS_CUENTAS_BANCARIAS = {
  PAGADORA: 'cuenta pagadora',
  RECAUDADORA: 'cuenta recaudadora',
};

export const formatearCuentasBancarias = (tipo) => {
  return (cuenta) => {
    return {
      ...cuenta,
      cuenta: `${cuenta.descripcion} - ${cuenta.nombre}`,
      tipo,
    };
  };
};

export const formatearCuentas = (tipo) => {
  return (cuenta) => {
    return {
      ...cuenta,
      value: cuenta.id,
      text: `${cuenta.nro} - ${cuenta.nombre} (${tipo.toUpperCase()})`,
      tipo,
    };
  };
};

export const getSedesPortal = async (apollo) => {
  const sql = gql`
    query {
      getSedes {
        id
        nombre
        unidad_negocio
      }
    }
  `;

  return await apollo.query({
    query: sql,
  });
};

export const getUnidadesNegocio = async (apollo) => {
  const sql = gql`
    query {
      NegociosAll {
        id
        nombre
      }
    }
  `;

  return await apollo.query({
    query: sql,
  });
};

export const getSedesPresupuestos = async () => {
  return await SedesServices.get();
};

export const obtenerTodasLasSedes = async (apollo) => {
  try {
    const [sedesPortal, sedesPresupuestos] = await Promise.all([getSedesPortal(apollo), getSedesPresupuestos()]);
    const sedesPortalFormateado = sedesPortal.data.getSedes.map(formatearSede(ORIGENES_SEDES.PORTAL));
    const sedesPresupuestosFormateado = sedesPresupuestos.data.datos.map(formatearSede(ORIGENES_SEDES.PRESUPUESTOS));

    return [...sedesPortalFormateado, ...sedesPresupuestosFormateado];
  } catch (error) {
    throw error;
  }
};

export const formatearPartidas = (partidas, partidasAplanadas, nivel, nivelaux) => {
  nivel += '&nbsp;&nbsp;&nbsp;';
  nivelaux += 1;

  partidas.forEach((partida) => {
    partidasAplanadas.push({
      ...partida,
      descripcion_tabulada: `${nivel}${partida.codigo} ${partida.nombre}`,
      disabled: !partida.acepta_registro,
      nivel: nivelaux,
      nombre: `${partida.codigo} ${partida.nombre}`,
      codigo: partida.codigo,
      saldo: partida?.saldo ? partida.saldo : 0,
    });

    formatearPartidas(partida.hijos, partidasAplanadas, nivel, nivelaux);
  });
};

export const TIPOS_DESEMBOLSOS = {
  TRANSFERENCIA: 'Transferencia',
  CHEQUE: 'Cheque',
  EFECTIVO: 'Efectivo',
};

export const establecerRangoFechas = (fecha1, fecha2) => {
  let fechaInicio;
  let fechaFin;

  if (new Date(fecha1).getTime() > new Date(fecha2).getTime()) {
    fechaInicio = fecha2;
    fechaFin = fecha1;
  } else {
    fechaInicio = fecha1;
    fechaFin = fecha2;
  }

  return {
    fechaInicio,
    fechaFin,
  };
};

export const obtenerQueryParamas = (params) => {
  const queryParams = Object.keys(params)
    .map((key) => {
      if (params[key]) {
        if (!Array.isArray(params[key])) {
          return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }

        if (params[key].length > 0) {
          const array = params[key].map((item) => `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
          return array.join('&');
        }
      }

      return null;
    })
    .filter((item) => item)
    .join('&');

  return queryParams;
};

export const URI_REPORTES = {
  REPORTE_TODOS: 'solicitudes-excel/reporte-todos',
  REPORTE_CONSOLIDADO_SUBTOTALES: 'solicitudes-excel/reporte-consolidado-subtotales',
  REPORTE_CONSOLIDADO_POR_CUENTA_ORIGEN: 'solicitudes-excel/reporte-consolidado-por-cuenta-origen',
  REPORTE_EJECUCION_PRESUPUESTARIA: 'presupuestos-excel/reporte-ejecucion-presupuestaria',
};

export const enlaceReporte = (params, URI) => {
  const queryParams = obtenerQueryParamas(params);

  const enlaceDescarga = `${process.env.VUE_APP_URL_API}${URI}${queryParams ? `?${queryParams}` : ''}`;

  return enlaceDescarga;
};

export const peticionCuentas1 = async (id) => {
  return CuentasPagadorasServices.getSede(id);
};

export const peticionCuentas2 = async (id, $apollo) => {
  const sql = gql`query{getSede(id: ${id}) { id nombre cuentasBancarias {id nombre nro descripcion estado idsede}}}`;

  const cuentas = $apollo.query({
    query: sql,
  });

  return cuentas;
};

export const formatearErrores = (errores) => {
  if (typeof errores == 'string') {
    return errores;
  }

  let erroresFormateados = '';

  Object.keys(errores).forEach((key) => {
    const itemsErrores = errores[key].map((item) => `<li>${item}</li>`).join('');

    erroresFormateados += itemsErrores;
  });

  return erroresFormateados;
};

export const cellRendererNumeroRegistro = (param) => {
  if (param.node.rowPinned) {
    return undefined;
  }

  return param.node.rowIndex + 1;
};

export const cellRendererActivoInactivo = (param) => {
  return param.data.estado ? 'ACTIVO' : "<span style='color:#ea5455;'>INACTIVO</span>";
};

export const cellRendererEliminadoEn = (param) => {
  return param.data.eliminado_en == null ? 'ACTIVO' : /*html */ `<span style='color:#ea5455;'>INACTIVO</span>`;
};

export const ACCIONES_A_CONFIRMAR = {
  ACTIVAR: 'activar',
  DESACTIVAR: 'desactivar',
  ELIMINAR: 'eliminar',
};

export const TIPOS_PRESUPUESTOS = {
  GASTO: 'gasto',
  INGRESO: 'ingreso',
  INGRESO_PROYECTADO: 'ingreso proyectado',
  INGRESO_ESTIMADO: 'ingreso estimado',
};

export const ESTADOS_DETALLE_TRANSACCION = {
  PENDIENTE: 'Pendiente',
  ACEPTADO: 'Aceptado',
  RECHAZADO: 'Rechazado',
};

export const aMonedaValueFormatter = (params) => {
  if (params.node.rowPinned) {
    return params.value;
  }

  return formatearValorAMoneda(params.value);
};

export const ACCIONES_CRUD = {
  REGISTRAR: 'registrar',
  EDITAR: 'editar',
  VERIFICAR: 'verificar',
  VER: 'ver',
};

export const DEPARTAMENTOS_UNIDADES = [
  // { text: 'Gastos Generales', value: 'Gastos Generales' },
  // { text: 'Diseño y Comunicación', value: 'Diseño y Comunicación' },
  // { text: 'Marketing', value: 'Marketing' },
  // { text: 'T.I', value: 'T.I' },
  // { text: 'Académica', value: 'Académica' },
  // { text: 'Administrativo, Contable y Finaciero', value: 'Administrativo, Contable y Finaciero' },
  // { text: 'Administrativo, Contable y Regional', value: 'Administrativo, Contable y Regional' },
  // { text: 'Produccion', value: 'Produccion' },
  // { text: 'Tecnico en Operaciones', value: 'Tecnico en Operaciones' },
  // { text: 'Gastos Generales', value: 'Gastos Generales' },
  { text: 'Administrativo, Contable y Finaciero', value: 'Administrativo, Contable y Finaciero' },
  { text: 'Marketing', value: 'Marketing' },
  { text: 'Académica', value: 'Académica' },
  { text: 'Talento Humano', value: 'Talento Humano' },
  { text: 'T.I', value: 'T.I' },
  { text: 'Diseño Gráfico', value: 'Diseño Gráfico' },
];

export const MESES = [
  { text: 'Enero', value: 'Enero' },
  { text: 'Febrero', value: 'Febrero' },
  { text: 'Marzo', value: 'Marzo' },
  { text: 'Abril', value: 'Abril' },
  { text: 'Mayo', value: 'Mayo' },
  { text: 'Junio', value: 'Junio' },
  { text: 'Julio', value: 'Julio' },
  { text: 'Agosto', value: 'Agosto' },
  { text: 'Septiembre', value: 'Septiembre' },
  { text: 'Octubre', value: 'Octubre' },
  { text: 'Noviembre', value: 'Noviembre' },
  { text: 'Diciembre', value: 'Diciembre' },
];

const camposEspecificos = (detalle, accionPresupuesto) => {
  const campos =
    accionPresupuesto == ACCIONES_CRUD.EDITAR
      ? {
          debe: 0,
          remover: detalle.remover,
        }
      : {
          id: detalle.id,
          cuenta_contable: detalle.clasificador.cuenta_contable
            ? `${detalle.clasificador.cuenta_contable.codigo} ${detalle.clasificador.cuenta_contable.nombre}`
            : '',
          debe: detalle.debe,
        };

  return campos;
};

export const mapearDetalleTransaccion = (accionPresupuesto) => {
  return (detalle) => ({
    clasificador_id: detalle.clasificador_id,
    clasificador: `${detalle.clasificador.codigo} ${detalle.clasificador.nombre}`,
    nombre: detalle.nombre,
    costo: detalle.costo,
    cantidad: detalle.cantidad,
    observaciones: detalle.observaciones,
    subtotal: detalle.subtotal,
    haber: detalle.haber,
    unidad: detalle.unidadMedida ? detalle.unidadMedida.descripcion : '',
    unidad_medida_id: detalle.unidad_medida_id,
    unidad_gasto: detalle.unidad_gasto,
    estado: detalle.estado,
    ...camposEspecificos(detalle, accionPresupuesto),
  });
};

export const mapearTransaccion = (data, presupuestoId, accion) => {
  return {
    id: data['id'],
    presupuesto_id: presupuestoId,
    total: data['total'],
    mes: data['mes'],
    numero_mes: data['numero_mes'],
    estado: data['estado'],
    tipo: data['tipo'],
    unidad_id: data['unidad_id'],
    detalles_transacciones: data['detalles_transacciones'].map(mapearDetalleTransaccion(accion)),
  };
};

export const formatearGrupos = (grupos, gruposAplanados, nivel, nivelaux) => {
  nivel += '&nbsp;&nbsp;&nbsp;';
  nivelaux += 1;

  grupos?.forEach((grupo) => {
    gruposAplanados.push({
      ...grupo,
      value: grupo.id,
      text: `${nivel}${grupo.codigo} ${grupo.nombre}`,
      label: `${grupo.codigo} ${grupo.nombre}`,
    });

    formatearGrupos(grupo.subgrupos, gruposAplanados, nivel, nivelaux);
  });
};

export const TIPOS_PRESUPUESTOS_CONSOLIDADOS = {
  GASTO: TIPOS_PRESUPUESTOS.GASTO,
  INGRESO: TIPOS_PRESUPUESTOS.INGRESO,
  GASTO_POR_GRUPO: 'gasto_por_grupo',
  INGRESO_POR_GRUPO: 'ingreso_por_grupo',
  GASTO_POR_GRUPO_POR_MESES: 'gasto_por_grupo_por_meses',
  INGRESO_POR_GRUPO_POR_MESES: 'ingreso_por_grupo_por_meses',
};

export const ID_SEDE_GRUPO_CORPORATIVO = 46;

export const obtenerUrl = (uri) => {
  return `${process.env.VUE_APP_URL_API}${uri}`;
};

export const UNIDADES_NEGOCIOS = {
  ESAM: 1,
  CCA: 2,
  CK: 3,
  CAST: 4,
  ESAM_LATAM: 5,
  CYBERCORP: 6,
  DBS: 10,
  CCTP: 12,
  ISPI: 14,
  UPI: 15,
};

export const CONCEPTOS_PAGOS = {
  MATRICULA: 'Matrícula',
  COLEGIATURA: 'Colegiatura',
  CERTIFICACION: 'Certificación',
  MENSUALIDADES: 'Mensualidades',
  MODALIDAD_TALLER_GRADO: 'Modalidad Taller de Grado',
  CURSOS_FORMACION_CONTINUA: 'Cursos de formación continua',
  CURSO: 'Curso',
  MENSUALIDAD: 'Mensualidad',
  CUOTA_INICIAL: 'Cuota Inicial',
  SIESAM_MEMBRESIA: 'Membresía SIESAM',
  SIESAM_IMPLEMENTACION: 'Implementación SIESAM',
  SIESAM_MODIFICACIONES: 'Modificaciones Software SIESAM ',
  INSCRIPCION: 'Inscripcion',
  CIBERKIDS_CURSO: 'Cursos',
};

export const CATEGORIAS = {
  CARRERA_TECNICO_MEDIO: 6,
  CARRERA_TECNICO_SUPERIOR: 7,
  CURSOS_CAPACITACION: 8,
  CURSOS_FORMACION_CONTINUA: 10,
  PROGRAMAS: 14,
  KINDER_CIBERKIDS: 35,
  SUBSCRIPCION_SIESAM: 42,
  INICIAL: 47,
  UPI_MAESTRIA: 49,
  UPI_LICENCIATURA: 54,
  UPI_TECNICO_UNIVERSITARIO: 55,
  PRE_UNIVERSITARIOS: 59,
  CURSOS_MODULARES: 60,
  CURSOS_LARGOS: 61,
  CURSOS_CORTOS: 62,
};

export const conceptosPagosRecurrentes = [
  CONCEPTOS_PAGOS.COLEGIATURA,
  CONCEPTOS_PAGOS.MENSUALIDADES,
  CONCEPTOS_PAGOS.CURSOS_FORMACION_CONTINUA,
  CONCEPTOS_PAGOS.CURSO,
  CONCEPTOS_PAGOS.MENSUALIDAD,
  CONCEPTOS_PAGOS.CIBERKIDS_CURSO,
  CONCEPTOS_PAGOS.SIESAM_MEMBRESIA,
];

export const conceptosNoPagablesSiEsContado = [
  CONCEPTOS_PAGOS.MATRICULA,
  CONCEPTOS_PAGOS.CUOTA_INICIAL,
  CONCEPTOS_PAGOS.INSCRIPCION,
];

export const conceptosPagosCertificacion = [CONCEPTOS_PAGOS.CERTIFICACION, CONCEPTOS_PAGOS.MODALIDAD_TALLER_GRADO];
